import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n'
import Button from '../../UI/Buttons/Button';
import { LossAversion } from './LossAversion';
import { StandardCancellation } from './StandardCancellation';
import { RetentionOffer } from './RetentionOffer';
import { RetentionOfferAcceptance } from './RetentionOfferAcceptance';
import usePageTitle from '../../../Hooks/usePageTitle';
import useBodyClass from '../../../Hooks/useBodyClass';
import { ThankyouPage } from './ThankyouPage';
import { useSearchParams } from 'react-router-dom';
import CancelationReasons from './CancelationReasons';
import { getOfferProps } from '../../Utilities/HelperFunctions';

export function SubscriberCampaignCancellation(props) {
    const { t, i18n } = useTranslation();
    const [currentPage, setCurrentPage] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const {termsText, campaignData, setErrors} = props;
    const [offerProps, setOfferProps] = useState("");
    const [firstStepCancellation, setFirstStepCancellation] = useState("");

    const updateQuery = (param) => {
        setSearchParams({ step: param })

    }

    const handlePageChange = (pageName) => {
        setCurrentPage(pageName);
        updateQuery(pageName?.toLowerCase());
    }

    useEffect(() => {
        const step = searchParams.get("step");

        if (step) {
            setCurrentPage(step.toUpperCase())
        }

    }, [searchParams])

    useEffect(() => {
        
        //on first render
        if(campaignData?.lossAversionMessage?.showLossAversionMessage){
            handlePageChange("LOSS_AVERSION");
        }else if(campaignData?.alternativeOffer?.showAlternativeOffer){
            handlePageChange("RETENTION_OFFER");
        }else{
            if(campaignData?.showCancellationForm){
                handlePageChange("CANCELLATION_REASONS"); 
            }else{
                handlePageChange("ORDER_CANCELLATION");
            }
        }
       
        if(campaignData){
           const offerProps = getOfferProps(campaignData);
           setOfferProps(offerProps);
        }
      
       }, [campaignData])

    return (
        <>
            {currentPage === "LOSS_AVERSION" && (<LossAversion handlePageChange={handlePageChange} campaignData={campaignData} firstStepCancellation={firstStepCancellation} />)}
            {currentPage === "RETENTION_OFFER" && <RetentionOffer handlePageChange={handlePageChange} campaignData={campaignData} firstStepCancellation={firstStepCancellation} {...offerProps}/>}
            {currentPage === "RETENTION_OFFER_ACCEPTANCE" && (<RetentionOfferAcceptance handlePageChange={handlePageChange} alternativeOffer={campaignData?.alternativeOffer} orderData={campaignData?.orderData} termsText={termsText} setErrors={setErrors} {...offerProps}/>)}
            {currentPage === "THANKYOU_PAGE" && <ThankyouPage handlePageChange={handlePageChange} orderData={campaignData?.orderData} alternativeOffer={campaignData?.alternativeOffer} {...offerProps} />}   {/* Once we'll land on this screen, going back will cause an error */}
            {["CANCELLATION_REASONS", "ORDER_CANCELLATION", "CONFIRM_CANCELLATION"].includes(currentPage) && (<StandardCancellation showCancellationForm={campaignData?.showCancellationForm}/>)}

        </>);

}